module.exports = __webpack_public_path__ + "static/media/ethereum-logo.f7a01aa0.png";